/* eslint-disable multiline-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable indent */
import React from 'react'
import { View, Text, Font, StyleSheet, Image } from '@react-pdf/renderer'
import { PropTypes } from 'prop-types'
import { themeConfig } from '../../config/theme.config'
import {
  PEDESTRIAN,
  BICYCLE,
  AUTO,
  TRANSIT,
  FREIGHT
} from '../../constants/modalTiers'
import SectionTitle from './SectionTitle'

Font.registerHyphenationCallback((word) => {
  const middle = Math.floor(word.length / 2)
  const part2 =
    word.substring(middle, word.length).length > middle
      ? [
          word.substring(middle, middle + middle),
          word.substring(middle + middle)
        ]
      : [word.substring(middle)]
  const parts =
    word.length === 1 ? [word] : [word.substring(0, middle), ...part2]
  return parts
})

const WeakestLinkVariables = ({
  name,
  weakestLinkVariables,
  weakestLinkScore,
  reportPedestrialImgUrl,
  reportBicycleImgUrl,
  reportAutoImgUrl,
  reportTransitImgUrl,
  reportFreightImgUrl
}) => {
  function getRating(score) {
    return score >= 1 && score <= 2.5
      ? 'Good'
      : score > 2.5 && score <= 3.5
      ? 'Okay'
      : score > 3.5
      ? 'Improve'
      : ''
  }

  const container = {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    flexDirection: 'row',
    padding: '10pt',
    height: 290
  }
  const text = {
    fontSize: 10,

    textAlign: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    color: themeConfig.lightTextColor,
    fontFamily: 'Roboto',
    fontStyle: 'italic'
  }
  const scoreText = {
    fontSize: 20,
    fontWeight: 900,
    alignSelf: 'center'
  }
  function getImg() {
    switch (name) {
      case PEDESTRIAN:
        return reportPedestrialImgUrl

      case BICYCLE:
        return reportBicycleImgUrl

      case TRANSIT:
        return reportTransitImgUrl
      case AUTO:
        return reportAutoImgUrl
      case FREIGHT:
        return reportAutoImgUrl
      default:
    }
  }

  return (
    <View
      style={{
        display: 'flex',
        marginTop: 20,
        justifyItems: 'center',
        alignItems: 'center',
        gap: '15px',
        width: '20%',
        maxWidth: '20%'
      }}
    >
      {getImg && (
        <Image
          src={getImg}
          style={{
            height: 40,
            width: 40,
            objectFit: 'contain',
            alignSelf: 'center'
          }}
        />
      )}

      {weakestLinkVariables.length && getRating(weakestLinkScore) !== 'Good' ? (
        weakestLinkVariables.map((variable, index) => (
          <Text style={[text]} key={`${variable}-text`}>
            {variable}
          </Text>
        ))
      ) : (
        <Text style={[text]}>-</Text>
      )}
    </View>
  )
}

export default WeakestLinkVariables

WeakestLinkVariables.propTypes = {
  name: PropTypes.string,
  weakestLinkVariables: PropTypes.array,
  weakestLinkScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}
